import { useContext, useEffect } from "react";
import Frame from "components/Frame/Frame";
import Menu from "components/Frame/Menu";
import { GlobalContext } from "components/WonderOrder/Grobal";

// Lang
const menuItems = {
  product: {
    title: "商品管理",
    items: {
      product_products:   { url: "/management/products", title: "商品一覧" },
      product_categories: { url: "/management/products/categories", title: "商品カテゴリ" }
    }
  },
  store: {
    title: "店舗管理",
    items: {
      store_stores: { url: "/management/stores", title: "店舗一覧" }
    }
  },
  company: {
    title: "契約管理",
    items: {
      company: { url: "/management/company", title: "契約者基本情報" }
    }
  }
};

const ManagementFrame = ({ children, title, menuCode }) => {
  const { managementMenuController } = useContext(GlobalContext);
  useEffect(() => {
    managementMenuController.initialize(menuItems, menuCode);
  }, []);
  const menu = <Menu controller={managementMenuController} />;
  return (<Frame title={title} side={menu}>
    {children}
  </Frame>);
};
export default ManagementFrame;